import { useTranslation } from 'react-i18next';
import React from "react";
import { Table } from "antd";
import YhDrawer from "@/erp_subpackage/components/YhDrawer";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailModel";
import { useGlobalModel, transPgToPagination } from "@/erp_subpackage/model/globalModel";
import YhTooltip from "@/erp_subpackage/components/YhTooltip"

export const WhConfirmDrawer = ({ modeKey, mode, rowCode, dispatch }) => {
    const { t } = useTranslation();
    const { wsConfirmVisible: visible, editList, lookList, setWsConfirmVisible, onWarehous } = usePurchaseRoDetailsModel();
    const tableList = mode === "edit" ? editList : lookList;
    const { user: { shopId, shopName, shopCode }, whDs, setMaterialInfo } = useGlobalModel(({ user, whDs }) => [user, whDs]);
    const onCancel = () => {
        setWsConfirmVisible(false);
    };

    const columns = [
        {
            title: t(`purchase.detail.WhConfirmDrawer.序号`),
            width: 80,
            dataIndex: "index",
            render: (t, r, i) => i + 1
        }, {
            title: t(`purchase.detail.WhConfirmDrawer.商品编号`),
            width: 120,
            dataIndex: 'materialCode',
            render: (text, record) => <YhTooltip text={text} onClick={() => setMaterialInfo(true, { materialCode: text, materialName: record.materialName })} />,
        }, {
            title: t(`purchase.detail.WhConfirmDrawer.商品名称`),
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: t(`purchase.detail.WhConfirmDrawer.出库数量`),
            width: 160,
            dataIndex: 'num',
        }
    ];

    return (
        <YhDrawer
            title={t(`purchase.detail.WhConfirmDrawer.库房确认`)}
            visible={visible}
            onClose={onCancel}
            okText={t(`purchase.detail.WhConfirmDrawer.保存`)}
            width={860}
            onOk={onWarehous}
        >
            <Table
                size="small"
                rowKey={record => record.id}
                columns={columns}
                dataSource={tableList}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YhDrawer>
    )
}